import React from 'react';
import { Box, Skeleton } from '@mui/material';

const UserMessageSkeleton = ({ isMobile = false }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end', // Align to right like user messages
        width: '100%',
        maxWidth: '100%',
        mb: 2,
        animation: 'fadeIn 0.5s ease-in-out',
        px: isMobile ? 1 : 0, // Add horizontal padding on mobile
      }}
    >
      {/* User message bubble skeleton */}
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-end',
          maxWidth: isMobile ? '85%' : '70%', // Wider on mobile
          minWidth: isMobile ? '150px' : '200px', // Smaller min width on mobile
        }}
      >
        {/* Main message skeleton with light orange tint */}
        <Skeleton
          variant="rectangular"
          width="100%"
          height={isMobile ? 50 : 60} // Slightly shorter on mobile
          sx={{
            borderRadius: '16px 16px 4px 16px', // Rounded corners like user messages
            mb: 1,
            background: 'linear-gradient(90deg, rgba(255, 152, 0, 0.08) 25%, rgba(255, 152, 0, 0.2) 50%, rgba(255, 152, 0, 0.08) 75%)',
            backgroundSize: '200% 100%',
            animation: 'skeletonWave 1.5s ease-in-out infinite',
          }}
        />
        
        {/* Additional text lines skeleton */}
        <Skeleton
          variant="text"
          width="80%"
          height={isMobile ? 16 : 20} // Smaller text line on mobile
          sx={{
            borderRadius: 1,
            background: 'linear-gradient(90deg, rgba(255, 152, 0, 0.06) 25%, rgba(255, 152, 0, 0.15) 50%, rgba(255, 152, 0, 0.06) 75%)',
            backgroundSize: '200% 100%',
            animation: 'skeletonWave 1.8s ease-in-out infinite',
          }}
        />
      </Box>

      {/* Global CSS Animations */}
      <style jsx global>{`
        @keyframes skeletonWave {
          0% {
            background-position: 200% 0;
          }
          100% {
            background-position: -200% 0;
          }
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </Box>
  );
};

export default UserMessageSkeleton;
